var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.82 9.256.768-.768-3.04-3.056h8.033V4.248H2.549l3.055-3.04-.768-.784L.42 4.84l4.4 4.416Z",
    fill: "#17294D"
  })));
};

export { SvgArrowLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMSAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuODIwNSA5LjI1Nkw1LjU4ODUgOC40ODhMMi41NDg1IDUuNDMySDEwLjU4MDVWNC4yNDhIMi41NDg1TDUuNjA0NSAxLjIwOEw0LjgzNjUgMC40MjRMMC40MjA1IDQuODRMNC44MjA1IDkuMjU2WiIgZmlsbD0iIzE3Mjk0RCIvPgo8L3N2Zz4K";